import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="w-full bg-gray-50 py-6 px-4 border-y border-gray-200" data-id="element-268">
      <div className="max-w-4xl mx-auto" data-id="element-269">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-270">
          {/* Star Rating */}
          <div className="flex items-center gap-2" data-id="element-271">
            <div className="flex gap-1" data-id="element-272">
              {[1, 2, 3, 4].map(star => <StarIcon key={star} className="w-5 h-5 fill-brand-red text-brand-red" aria-hidden="true" data-id="element-273" />)}
              <StarIcon className="w-5 h-5 fill-brand-red text-brand-red opacity-80" aria-hidden="true" data-id="element-274" />
            </div>
            <span className="text-lg font-bold text-gray-900" data-id="element-275">4.8</span>
          </div>

          {/* Review Count */}
          <div className="text-gray-700 text-center sm:text-left" data-id="element-276">
            <span className="font-semibold" data-id="element-277">15,000+ men</span> who acted while
            the window was open
          </div>
        </motion.div>
      </div>
    </section>;
}